// extracted by mini-css-extract-plugin
var _1 = "LoadingContainer-Byyt2";
var _2 = "LoadingFullScreen-KAI6W";
export { _1 as "LoadingContainer", _2 as "LoadingFullScreen" }
